import { TagsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { AttachmentStatus } from '../../../../enums/attachmentStatus'
import { Attachment } from '../../../../types/attachment'
import { AttachmentTag } from '../AttachmentTag'
import { FailedAttachmentTag } from './elements/FailedAttachmentTag'

export interface CompletedAttachmentTagsProps {
  completedAttachments: Attachment[]
  onRemoveAttachment: (id: string) => void
  onRetryUpload: (id: string) => void
}

export const CompletedAttachmentTags = ({
  completedAttachments,
  onRemoveAttachment,
  onRetryUpload,
}: CompletedAttachmentTagsProps): ReactElement | null => {
  const handleRemoveAttachment = useCallback((id: string) => onRemoveAttachment(id), [onRemoveAttachment])
  const handleRetryUpload = useCallback((id: string) => onRetryUpload(id), [onRetryUpload])

  if (!completedAttachments.length) {
    return null
  }

  return (
    <TagsGroup>
      {completedAttachments.map((attachment) => {
        const { errorType, fileName, fileSize, id, isRetryable, status } = attachment

        return status === AttachmentStatus.Done ? (
          <AttachmentTag fileName={fileName} fileSize={fileSize} key={id} onClose={() => handleRemoveAttachment(id)} />
        ) : (
          <FailedAttachmentTag
            errorType={errorType}
            fileName={fileName}
            isRetryable={isRetryable}
            key={id}
            onRemove={() => handleRemoveAttachment(id)}
            onRetry={() => handleRetryUpload(id)}
          />
        )
      })}
    </TagsGroup>
  )
}
